import { useEffect, useState } from "react";
import InfoModal from "../modals/infoModal";
import locale from "antd/es/date-picker/locale/ru_RU";
import { Alert, BadgeProps, CalendarProps, Skeleton, Tooltip } from "antd";
import { Badge, Calendar } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import { InfoCircleOutlined } from "@ant-design/icons";

const BanksInfo = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [item, setItem] = useState({});
  const today = new Date();
  const [selectedValue, setSelectedValue] = useState<any>(dayjs(today));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const onSelect = (newValue: Dayjs) => {
    setSelectedValue(newValue);
  };

  let type = localStorage.getItem("usertype");

  const closeModal = (value: any) => {
    setModalOpen(false);
  };

  const getListData = (value: Dayjs) => {
    let listData: { type: string; content: string }[] = []; // Specify the type of listData
    console.log("GGG", value.month());
    switch (`${value.date()}.${value.month()}`) {
      case "8.6":
        listData = [
          {
            type: "warning",
            content: "Подача уведомления об авансном платеже",
          },
        ];
        break;
      case "10.6":
        listData = [
          {
            type: "warning",
            content: "Уплата авансного платежа по упрощенной системе.",
          },
        ];
        break;

      case "18.6":
        listData = [
          { type: "success", content: "Рассмотрение заявки на кредит" },
        ];
        break;

      case "8.7":
        listData = [
          {
            type: "warning",
            content: "Подача уведомления об авансном платеже",
          },
        ];
        break;
      case "10.7":
        listData = [
          {
            type: "warning",
            content: "Уплата авансного платежа по упрощенной системе.",
          },
        ];
        break;
      default:
    }
    return listData || [];
  };

  const dateCellRender = (value: Dayjs) => {
    const listData = getListData(value);
    return (
      <ul className="events">
        {listData.map((item) => (
          <li key={item.content}>
            <Badge
              status={item.type as BadgeProps["status"]}
              text={item.content}
            />
          </li>
        ))}
      </ul>
    );
  };

  const cellRender: CalendarProps<Dayjs>["cellRender"] = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    return info.originNode;
  };

  return (
    <>
      {type != "admin" && (
        <>
          <div>
            {type == "admin" && <h2>Банковские продукты</h2>}

            {type == "admin" && (
              <div className="tabs-group">
                <div className="flex-description card">
                  <div className="flex-column gap-0_25 ">
                    <InfoCircleOutlined className="info" />
                    <span className="color-gray">
                      Кредитный рейтинг в банке
                    </span>
                    <span>8</span>
                  </div>
                  <div className="flex-column gap-0_25">
                    <span className="color-gray">
                      Количество поданных заявок
                    </span>
                    <span>12</span>
                  </div>
                  <div className="flex-column gap-0_25">
                    <span className="color-gray">Процент одобрения заявок</span>
                    <span>93%</span>
                  </div>
                  <div className="flex-column gap-0_25">
                    <span className="color-gray">
                      Среднее время обработки заявок
                    </span>
                    <span>2 дня</span>
                  </div>
                  <div className="flex-column gap-0_25">
                    <span className="color-gray">Финансовая нагрузка</span>
                    <span>15%</span>
                  </div>
                </div>
              </div>
            )}
            {type == "admin" && (
              <div className="white-block grid4" style={{ gap: "15px" }}>
                <div>
                  <div className="block-title flex-space">
                    Финансовая доступность
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Доступный лимит по кредитной линии
                    </span>
                    <span>20 000 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Одобренный лимит</span>
                    <span>100 000 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Использованный лимит</span>0
                    руб.
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Статус лимита</span>
                    Ожидает активации
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Дата последнего обновления лимита
                    </span>
                    Сегодня
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    Контрактное финансирование
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Доступные средства под контракты
                    </span>
                    <span>20 000 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Текущие заявки по контрактному финансированию
                    </span>
                    <span>3</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Процент одобрения заявок по контрактам
                    </span>
                    100%
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Среднее время рассмотрения заявки
                    </span>
                    2 дня
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    Подбор льготных программ
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Число доступных программ поддержки
                    </span>
                    <span>6</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Число программ, соответствующих профилю компании
                    </span>
                    <span>2</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Число программ, по которым поданы заявки
                    </span>
                    0
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Статус поданных заявок</span>
                    Ожидание
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">Гарантийный фонд</div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Наличие доступа к гарантийному фонду
                    </span>
                    <span>Да</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      {" "}
                      Размер доступного лимита через фонд
                    </span>
                    <span>1 000 000 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Статус участия в программе
                    </span>
                    Ожидает одобрения
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Срок действия участия</span>
                    10 лет
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    Субсидированное кредитование
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Доступные субсидированные программы
                    </span>
                    <span>2</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Процентная ставка</span>
                    <span>5%</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Срок действия программы</span>6
                    мес.
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Уровень покрытия процента
                    </span>
                    Частичное
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    Отсрочка платежа / платежная гарантия
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Доступность отсрочки платежа
                    </span>
                    <span>Да</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Максимальный срок отсрочки
                    </span>
                    <span>2 мес.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Максимальная сумма отсрочки
                    </span>
                    500 000руб.
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Уровень доверия со стороны банка{" "}
                    </span>
                    94
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Число одобренных заявок</span>
                    12
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    BNPL и маркетплейс
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Доступный лимит BNPL</span>
                    <span>200 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Число покупок с отсрочкой
                    </span>
                    <span>15</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Среднее время одобрения BNPL
                    </span>
                    1 день
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Общая сумма покупок с отсрочкой
                    </span>
                    1 500 000руб.
                  </div>
                </div>
                <div>
                  <div className="block-title flex-space">
                    Кредит под оборудование
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Доступность программы</span>
                    <span>Да</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">
                      Максимальная сумма кредита
                    </span>
                    <span>10 000 000 руб.</span>
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Процентная ставка</span>2%
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Срок кредитования</span>
                    20 лет
                  </div>
                  <div className="flex-column gap-0_25 flex-space">
                    <span className="color-gray">Статус заявки</span>
                    Черновик
                  </div>
                </div>
              </div>
            )}
          </div>

        </>
      )}
      <InfoModal open={modalOpen} isCloseModal={closeModal} item={item} />
    </>
  );
};
export default BanksInfo;
